'use client'
import { motion } from 'framer-motion'

export const HeroBannerAnimatedLogo = () => {
  const animationSettings = {
    initial: { y: 200, scale: 0.6, opacity: 0.8 },
    animate: { y: 0, scale: 1, opacity: 1 },
    transition: { duration: 0.7 }
  }

  const animationSettingsRect = {
    initial: { y: 200, opacity: 0.4 },
    animate: { y: 0, opacity: 1 },
    transition: { duration: 0.7 }
  }

  return (
    <>
      <motion.div
        {...animationSettings}
        className='md:-ml-20 -mr-28 sm:-mr-0 z-20'
      >
        <motion.img
          src={'/imgs/hero_new_bot.png'}
          alt='hero bot'
          className='z-10 w-[75%] mx-auto 2xl:w-full h-auto hidden sm:block animated-hero'
        />
        <motion.img
          src={'/imgs/hero_new_bot.png'}
          alt='hero bot'
          className='z-10 min-h-[300px] min-w-[300px] sm:hidden animated-hero'
        />
      </motion.div>
      <div className='absolute z-10 inset-0 hidden md:block -translate-x-10 lg:-translate-x-6 2xl:-translate-x-4 translate-y-20 lg:translate-y-28 2xl:translate-y-36 rotate-3'>
        {/* <motion.div {...animationSettingsRect} className='w-full h-full'>
          <img
            {...animationSettingsRect}
            src={'/imgs/clip_path.png'}
            alt='hero background'
            className='w-[70%] lg:w-[62%] h-auto'

          />
        </motion.div> */}
        <motion.img
          {...animationSettingsRect}
          src={'/imgs/clip_path.png'}
          alt='hero background'
          className='w-[70%] lg:w-[62%] h-auto'
        />
      </div>
    </>
  )
}
